const nonTechnicalEvents = [
	{
		img: "/assets/post.webp",
		title: "Posteroid",
		subtitle:
			"BASED ON POSTER MAKING",
	},
	{
		img: "/assets/ppt.webp",
		title: "Presentation",
		subtitle:
			"A Presentation conveys information from a speaker to an audiance. it helps you to create innovative ideas..So come up with Creative and Interesting slides to illustrate your talks.",
	},
	{
		img: "/assets/sing.webp",
		title: "Kala Se Kalakar",
		subtitle:
			"No matter which art form you’re inclined to, we’ve bought to you an opportunity to show them all. Participate in your interest for Dancing, Singing, Instrumental or all of them.",
	},
	{
		img: "/assets/quiz.webp",
		title: "Quizeria",
		subtitle: "Show your knowledge through some easy quests, compete with your buddies and grab the first position. So what's left to you for thinking, take a quick call and register yourself for the Quizeria also invite your friends for the same ",
	},
	{
		img: "/assets/min.webp",
		title: "Just a minute",
		subtitle: "Just a minute is a event where you get the opportunity to present your thoughts on the topic for 1 minute.",
	},
	{
		img: "/assets/aalu.webp",
		title: "Stand-up Comedy",
		subtitle: "Stand-up comedy is a comedy performance to a live audience where the participants have to showcase their comedic skills and look forth that they give their audience a laugh to remember the one who makes the audience laugh the most will be the 'CHOSEN' one"
	}
];

export default nonTechnicalEvents;
